/// <reference path="./pocmemberform.js" />
// what is this reference path for ???
import React from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import '../../../styles/Forms.css';
import { HHIEButton } from '../../utility/HHIEButton';
export function SaveSubmitButtons(props) {

    return (
        <Row style={{ padding: "15px" }}>
            <Col></Col>
            <Col>
                {
                    !props.saving ?
                        <div className="d-flex justify-content-center" style={{ padding: "4px" }}>
                            <HHIEButton
                                id="save-for-later"
                                variant="primary"
                                size="sm"
                                className="style-btns"
                                onClick={() => { props.save("leave"); }}
                                title="Save for Later"
                            />

                            <HHIEButton
                                id="save-and-continue"
                                variant="primary"
                                size="sm"
                                className="style-btns"
                                onClick={() => { props.save("continue"); }}
                                title="Save and Continue"
                            />
                            {
                                props.saveAndNewAllowed ?
                                    <HHIEButton
                                        id="save-and-new"
                                        variant="primary"
                                        size="sm"
                                        className="style-btns"
                                        onClick={() => { props.save("new"); }}
                                        title="Save and New"
                                    />
                                    : <></>
                            }
                            {
                                props.submitButtonExists ?
                                    <HHIEButton
                                        id="submit"
                                        variant="primary"
                                        size="sm"
                                        className="style-btns"
                                        onClick={() => { props.submit() }}
                                        disabled={props.disabled}
                                        title="Submit to HHIE"
                                    />
                                    : <></>
                            }
                        </div>
                        : 
                        <div className="d-flex justify-content-center" style={{ padding: "4px" }}>
                            <HHIEButton
                                disabled
                                id="saving-spinner"
                                variant="primary"
                                size="sm"
                                title={<Spinner animation="border" />}
                            />
                        </div>
                }
            </Col>
            <Col></Col>
        </Row>
    );
}